import { css } from 'styled-system/css';
import { iso } from './isometric';

type Pt3 = readonly [number, number, number];

export function ExplodePins({
  x,
  y,
  z0,
  z1,
  w,
  depth,
}: {
  x: number;
  y: number;
  z0: number;
  z1: number;
  w: number;
  depth: number;
}) {
  const corners: Pt3[] = [
    [x, y, z0],
    [x + w, y, z0],
    [x + w, y + depth, z0],
    [x, y + depth, z0],
  ];
  return (
    <g
      className={css({
        fill: 'none',
        strokeDasharray: '2.5 3',
        strokeWidth: '0.7',
        opacity: 0.65,
      })}
    >
      {corners.map(([cx, cy], i) => {
        const a = iso(cx, cy, z0);
        const b = iso(cx, cy, z1);
        return <line key={i} x1={a.x} y1={a.y} x2={b.x} y2={b.y} />;
      })}
    </g>
  );
}
